import {onEachElements, getElementSizing} from "@straylightagency/utils/dom";

export default class Dash {
    constructor(element, {onShow, onHide}) {
        this.element = element;
        this.animation = element.getAttribute('data-dash') || undefined;
        this.delay = parseInt( element.getAttribute('data-dash-delay') ) || 0;
        this.offset = parseInt( element.getAttribute('data-dash-offset') ) || 0;

        this.onShowCallback = onShow;
        this.onHideCallback = onHide;

        this.isActive = false;

        setTimeout( () => {
            this.sizing = getElementSizing( this.element );

            if ( this.animation ) {
                element.classList.add( this.animation );
            }

            this.event = () => {
                if ( ! element.isConnected || ! document.contains( element ) ) {
                    this.destruct();
                } else {
                    this.handle();
                }
            };

            window.addEventListener('scroll', this.event.bind( this ) );

            this.handle();
        } );
    }

    handle() {
        this.isActive = window.scrollY + window.innerHeight >= this.sizing.y + this.offset;

        if ( this.isActive ) {
            setTimeout( () => typeof this.onShowCallback === "function" ? this.onShowCallback( this.element ) : undefined, this.delay );
        } else {
            setTimeout( () => typeof this.onHideCallback === "function" ? this.onHideCallback( this.element ) : undefined, this.delay );
        }
    }

    destruct() {
        window.removeEventListener( 'scroll', this.event );
    }

    static init(selector = "[data-dash]") {
        onEachElements( selector, el => {
            new Dash( el, {
                onShow: el => el.classList.add( el.getAttribute('data-dash-class') || 'dash-animated' ),
                onHide: el => el.classList.remove( el.getAttribute('data-dash-class') || 'dash-animated' )
            } );
        } );
    }
}